import * as types from './types';

export default {
    [types.SET_CURRENCY_CONVERSION_TABLE](state, currencyConversionTable) {
        state.currencyConversionTable = currencyConversionTable;
    },
    [types.SET_VISITOR_CURRENCY](state, payload) {
        state.visitorCurrency = payload;
    },
};